import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { planLimitRejection } from '@app/shared/tenant-lifecycle/plan-limit';
import { PlanLimitService } from '@app/shared/tenant-lifecycle/plan-limit.service';
import { catchError } from 'rxjs/operators';

/**
 * Turns plan limit rejections of the tenant API (403 with reason
 * `plan_limit_podcasts` or `plan_limit_seats`) into a friendly toast. The
 * sibling of `tenantLifecycleInterceptor`; the error is rethrown unchanged so
 * callers still stop their loading state.
 */
export const planLimitInterceptor: HttpInterceptorFn = (request, next) => {
  const planLimit = inject(PlanLimitService);

  return next(request).pipe(
    catchError((error: unknown) => {
      const rejection = planLimitRejection(error);
      if (rejection !== null) {
        planLimit.handleRejection(rejection);
      }
      throw error;
    }),
  );
};
